/**
 * Route for `sub-network-creation`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { SubNetworkCreationPage } from "../features/sub-network-creation/SubNetworkCreationPage";

export const subNetworkCreationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/sub-network-creation",
	component: SubNetworkCreationPage,
});

export default subNetworkCreationRoute;
